import { render, staticRenderFns } from "./AppStoreButtons.vue?vue&type=template&id=1e50f13a&"
import script from "./AppStoreButtons.vue?vue&type=script&lang=js&"
export * from "./AppStoreButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports